import axios from 'axios'

import { cleanBlankValue } from 'utils/helper'

export const getFinancePurchaseDeliverys = (params) => {
  return axios.get('/finance/purchaseDeliveries', { params })
}

export const getTotalFinancePurchaseDeliveries = (params) => {
  return axios.get('/finance/purchaseDeliveries/totals', { params })
}

export const addFinancePurchaseDelivery = (data) => {
  return axios.post('/finance/purchaseDeliveries', data)
}

export const editFinancePurchaseDelivery = (data) => {
  return axios.put(`/finance/purchaseDeliveries/${data.id}`, data)
}

export const deleteOnAddFinancePurchaseDeliveryAttachment = (url) => {
  return axios.delete('/finance/purchaseDeliveries/attachments', { data: { url } })
}

export const deleteOnEditFinancePurchaseDeliveryAttachment = (id, url) => {
  return axios.delete(`/finance/purchaseDeliveries/${id}/attachments`, { data: { url } })
}

export const getFinancePurchaseDelivery = (id, params) => {
  return axios.get(`/finance/purchaseDeliveries/${id}`, { params })
}

export const getFinancePurchaseDeliveryLog = ({ id, params } = {}) => {
  return axios.get(`/finance/purchaseDeliveries/${id}/logs`, { params })
}

// export const changeFinancePurchaseDeliveryStatus = (id, data) => {
//   return axios.patch(`/finance/purchaseDeliveries/${id}/status`, data)
// }

export const deleteFinancePurchaseDelivery = (id) => {
  return axios.delete(`/finance/purchaseDeliveries/${id}`)
}

export const getFinancePurchaseDeliveryMerged = (params) => {
  return axios.get('/finance/purchaseDeliveries/merged', { params })
}

// export const getFinancePurchaseDeliveryPublicUrl = (id) => {
//   return axios.get(`/finance/purchaseDeliveries/${id}/publicUrl`)
// }

export const getFinancePurchaseDeliveryPublicUrl = (id) => {
  return axios.get(`/finance/purchaseDeliveries/${id}/publicUrl`)
}

export const exportFinancePurchaseDelivery = (params) => {
  params = cleanBlankValue(params)

  return axios.get('/finance/purchaseDeliveries/export?', { responseType: 'arraybuffer', params })
}

export const getFinancePurchaseDeliveryWaTemplate = (id) => {
  return axios.get(`/finance/purchaseDeliveries/${id}/whatsapp`)
}

export const getFinancePurchaseDeliveryEmailTemplate = (id) => {
  return axios.get(`/finance/purchaseDeliveries/${id}/email`)
}

export const sendFinancePurchaseDeliveryEmail = (id, data) => {
  return axios.post(`/finance/purchaseDeliveries/${id}/email`, data)
}

export const getFinancePurchaseDeliverySmsTemplate = (id) => {
  return axios.get(`/finance/purchaseDeliveries/${id}/sms`)
}

export const sendFinancePurchaseDeliverySms = (id, data) => {
  return axios.post(`/finance/purchaseDeliveries/${id}/sms`, data)
}

export const inputMassDeleteFinancePurchaseDelivery = (data) => {
  return axios.post('/finance/purchaseDeliveries/inputMassDelete', data)
}

export const executeMassDeleteFinancePurchaseDelivery = (data) => {
  return axios.delete('/finance/purchaseDeliveries/executeMassDelete', { data })
}

export const inputMassCreateFinancePurchaseDelivery = (data) => {
  return axios.post('/finance/purchaseDeliveries/inputMassPurchaseDelivery', data)
}

export const getMinTransDateFinancePurchaseDelivery = (data) => {
  return axios.post('/finance/purchaseDeliveries/mass/minDate', data)
}

export const executeMassCreateFinancePurchaseDelivery = (data) => {
  return axios.post('/finance/purchaseDeliveries/executeMassPurchaseDelivery', data)
}

export const editOnCompletePurchaseDelivery = (data) => {
  return axios.patch(`/finance/purchaseDeliveries/${data.id}`, data)
}

export const approveFinancePurchaseDelivery = ({ id }) => {
  return axios.post(`/finance/purchaseDeliveries/${id}/approve`)
}

export const rejectFinancePurchaseDelivery = ({ id, body }) => {
  return axios.post(`/finance/purchaseDeliveries/${id}/reject`, body)
}

export const revertApprovalFinancePurchaseDelivery = ({ id }) => {
  return axios.post(`/finance/purchaseDeliveries/${id}/revert`)
}
